import React from "react";

function Product_Details_Management_Edit() {
  return (
    <div className="p-5 border-2 border-gray-200 rounded-xl ">
      {/* Title */}
      <div className="border-b pb-2">
        <p className="text-lg font-semibold text-gray-700">
          Product Management Details
        </p>
      </div>

      {/* Table-like structure */}
      <div className="mt-5 flex px-5  flex-row flex-wrap">
        <table className="w-1/2   text-sm font-medium">
          <tbody>
            {/* Row 1 */}
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Buyer Added By :</td>
              <td className=" py-3  w-1/2 ">Administrator</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Product Time :</td>
              <td className=" py-3  w-1/2 ">13:30</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">
                Product Last Modified By :
              </td>
              <td className=" py-3  w-1/2 ">13:30</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Product Owner :</td>
              <td className=" py-3  w-1/2 ">Administrator</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">
                Product Recommended Role :
              </td>
              <td className=" py-3  w-1/2 ">.......</td>
            </tr>
          </tbody>
        </table>

        <table className="w-1/2 text-sm  font-medium">
          <tbody>
            {/* Row 1 */}
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">
                Buyer Added Date :
              </td>
              <td className=" py-3  w-1/2 ">12/11/2024</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">
                Product Last Modified By:
              </td>
              <td className=" py-3  w-1/2 ">Administrator</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">
                Product Last Modified TIme :
              </td>
              <td className=" py-3  w-1/2 ">13:30 </td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Next Step</td>
              <td className=" py-3  w-1/2 ">............</td>
            </tr>
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Tags</td>
              <td className=" py-3  w-1/2 ">............</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Product_Details_Management_Edit;
